<div class="app-layout">
  <mat-sidenav-container class="sidenav-container">
    <!-- Sidenav - Direct child of container -->
    <mat-sidenav 
      #sidenav 
      [mode]="sidebarMode" 
      [opened]="sidebarOpen"
      class="sidenav">
      
      <!-- Sidebar Content Component -->
      <s-sidebar 
        [config]="sidebarConfig"
        (navItemClick)="onNavItemClick($event)">
      </s-sidebar>
    </mat-sidenav>

    <!-- Main Content -->
    <mat-sidenav-content class="main-content">
      <!-- Header Component -->
      <s-header 
        [config]="headerConfig"
        (menuToggle)="onMenuToggle()">
      </s-header>

      <!-- Content area -->
      <div class="content-area">
        <ng-content></ng-content>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div> 